import { useTranslation } from "react-i18next";
import type { VersionBump } from "../../../api/content/versionDecoders";
import { bumpText } from "../labels/versionText";

/** What a merge decision recorded about versions. */
export interface MergeVersions {
  readonly changeLine: string;
  readonly versionBump: VersionBump | null;
  readonly itemBumps: Readonly<Record<string, VersionBump>>;
}

/** A merge's change line and the bumps the person merging confirmed, by name. */
export default function ConfirmedVersions({ decision, nameOf }: { decision: MergeVersions; nameOf: (itemId: string) => string }) {
  const { t } = useTranslation();
  const bumps = [
    ...(decision.versionBump === null ? [] : [t("versions.confirmed.bump", { subject: t("versions.projectContent"), bump: bumpText(t, decision.versionBump) })]),
    ...Object.entries(decision.itemBumps).map(([itemId, bump]) => t("versions.confirmed.bump", { subject: nameOf(itemId), bump: bumpText(t, bump) })),
  ];
  if (decision.changeLine === "" && bumps.length === 0) return null;
  return (
    <span className="app-text-muted block text-xs">
      {[decision.changeLine === "" ? null : t("versions.confirmed.changeLine", { line: decision.changeLine }), ...bumps].filter((part) => part !== null).join(" · ")}
    </span>
  );
}
